import { dsvFormat } from 'd3';
import { t } from 'i18next';

import { downloadBlob, getFormatedDate, getVolumeData, VolumeWithAsset } from './utils';

/**
 * Main function to export CSV file
 */
export const exportVolumeCsvReport = (projectName: string, selectedVolumes: VolumeWithAsset[]) => {
  const nameTranslated = t('export.name', { ns: 'skyviewReport' }) as string;
  const cutTranslated = t('common.cut', { ns: 'skyviewVolumeCalculation' }) as string;
  const fillTranslated = t('common.fill', {
    ns: 'skyviewVolumeCalculation',
  }) as string;
  const surface2dTranslated = t('common.surface2d', { ns: 'skyviewVolumeCalculation' }) as string;
  const surface3dTranslated = t('common.surface3d', { ns: 'skyviewVolumeCalculation' }) as string;

  const content = [
    `${nameTranslated}\t${cutTranslated}\t${fillTranslated}\t${surface3dTranslated}\t${surface2dTranslated}`,
    ...getVolumeData(selectedVolumes).map((data) => {
      if (!data.sourceName) {
        throw new Error('Volume Report Data must have a source name.');
      }

      const cut = data.cut.toFixed(2);
      const fill = data.fill.toFixed(2);
      const area = data.type === 'prism' ? (data.cutArea + data.fillArea).toFixed(2) : '-';
      const planArea =
        data.type === 'prism' ? (data.cutPlanArea + data.fillPlanArea).toFixed(2) : '-';

      return `${data.name} (${data.targetAssetName} - ${data.sourceName})\t${cut}\t${fill}\t${area}\t${planArea}`;
    }),
  ].join('\n');

  downloadBlob(content, `${projectName}_${getFormatedDate()}`, 'csv');
};

export function formatDsvData(rows: { [x: string]: string }[], columns?: string[]): string {
  return dsvFormat('\t').format(rows, columns);
}
